import { useMediaQuery } from 'react-responsive';

export function useScreenSize() {
  const isMobile = useMediaQuery({ query: '(max-width: 1024px)' });
  const isSmallDesktop = useMediaQuery({ query: '(max-width: 1300px)' });

  return { isMobile, isSmallDesktop };
}
